// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__-BFoa","productName":"Table_productName__21B-1"};